import styled from 'styled-components';

export const LiveArenaWidgetCapsuleContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-items: center;
    justify-content: center;

    height: 100%;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        height: 90%;
    }
`;
